import * as React from "react";
import { Switch, Route } from "react-router-dom";

import { Box, NotFound } from "../../../components";
import { MainLayout } from "../../../layouts";

import Login from "./LoginContainer";
import Register from "./RegisterContainer";
import "./Account.css";

const leftPanelIcon: string = require("../assets/client_bg.png");
const rightPanelIcon: string = require("../assets/designer_bg.png");

const StaticPages = props => (
  <MainLayout className="account" separateChildren>
    <section className="content">
      <Box hasShadow>
        <div className="row account-container">
          <div className="col-md-5 col-md-push-7 content__right">
            <div className="login-box">
              <img className="login-box__icon" src={rightPanelIcon} />
              <Switch>
                <Route path="/account/login" component={Login} />
                <Route path="/account/register" component={Register} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </div>
          <div className="col-md-7 col-md-pull-5 content__left">
            <div className="intro-box">
              <img className="intro-box__icon" src={leftPanelIcon} />
              <h2>Chào mừng !</h2>
              <p>
                Với Thiết Kế Hỏa Tốc - Bạn sẽ có một trải nghiệm tốt nhất về
                dịch vụ và có được sản phẩm thiết kế chất lượng tốt nhất.
                <br />
                Thành viên của Express Design sẽ được tư vấn miễn phí cho mọi
                sản phẩm thiết kế và hỗ trợ tối đa trong việc in ấn/ xuất bản...
              </p>
              <p>Hãy để công việc thiết kế trở nên thật đơn giản!</p>

              <div className="intro-box__footer" />
            </div>
          </div>
        </div>
      </Box>
    </section>
  </MainLayout>
);

export default StaticPages;



// WEBPACK FOOTER //
// ./src/routes/Account/components/Account.tsx